export const DURATIONS_DATA = ['4 minutes', '8 minutes', '12 minutes'];

export const CIRCUITS_NUMBER = ['1 circuit', '2 circuits', '4 circuits'];

export const MUSCLE_GROUPS = ['Whole body', 'Core', 'Upper Body', 'Lower Body', 'Cardio'];
